import React from 'react';
import PartnerDisplay from './partner-display';

function getCategoryPartners(catId, partners) {
    return partners.filter(partner => partner.partnerCategoryId === catId);
}

function buildPartnersPrintData(partners) {
    let availableCategories = [], result = [];
    partners.forEach(partner => {
        if (partner.partnerCategory && !availableCategories.some(item=>item.id === partner.partnerCategory.id)) {
            availableCategories.push(partner.partnerCategory)
        }
    });
    availableCategories.forEach(cat => {
        result.push({
            category: cat,
            order: cat.order,
            partners: getCategoryPartners(cat.id, partners)
        });
    });
    result.push({
        category: null,
        order: null,
        partners: getCategoryPartners(null, partners)
    });
    return result.sort((a, b) => {
        return a.order - b.order;
    });

}

export default function PartnersDisplay(props) {
    const {partners} = props;
    const grouped = buildPartnersPrintData(partners);
    return (
        <div className="partner-groups">
            {grouped.map((item) => {
                return (<div className="partner-group" key={item.category ? item.category.id : new Date().getTime()}>
                    {item.category && <h4 className="group-title">{item.category.name}</h4>}
                    <div className="partners-list">
                        {item.partners.map((partner) => {
                            return (<PartnerDisplay partner={partner} key={`partner-${partner.id}`}/>)
                        })}
                    </div>
                </div>)
            })}
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/js/components/partner/partners-display.js